module.exports = __webpack_public_path__ + "img/rating.8316a17b.png";